export const getAttachmentDisplayName = (key: string) => {
  const fileName = key.split('/').pop() || key;
  return decodeURIComponent(fileName.replace(/\+/g, ' '));
};
